import { Moon } from "lucide-react"
import { Button } from "@/components/ui/button"
import { SleepStepContainer } from "../SleepStepContainer"
import { useSleepForm } from "../SleepFormContext"

interface SoundLevelStepProps {
  soundLevels: { id: string; level: string }[]
  onNext: () => void
}

export function SoundLevelStep({ soundLevels, onNext }: SoundLevelStepProps) {
  const form = useSleepForm()

  return (
    <SleepStepContainer>
      <div className="space-y-2">
        <h3 className="text-lg font-medium text-center mb-4">
          What was the sound level?
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-xl mx-auto">
          {soundLevels.map((level) => (
            <Button
              key={level.id}
              type="button"
              variant={form.watch("sound_level_id") === level.id ? "default" : "outline"}
              className="w-full py-3 px-4 h-auto text-left justify-start hover:bg-accent/50 whitespace-normal"
              onClick={() => {
                form.setValue("sound_level_id", level.id)
                form.clearErrors("sound_level_id")
                onNext()
              }}
            >
              <Moon className="mr-2 h-4 w-4 shrink-0" />
              <span className="text-sm line-clamp-2">{level.level}</span>
            </Button>
          ))}
        </div>
      </div>
    </SleepStepContainer>
  )
}